import React from 'react';
import noAccess from '../../assets/images/no_access.png';
import './styles.less';

const NoAccessPage = (props:{title:string,message:string,t:any}) => {
  const { title,message,t}  = props;
  return (
    <div className="no-access-page-container">
      <div className='no-access-image-container'>
          <img src={noAccess} alt={'no access page'} />
      </div>
      <div className='no-access-title-container'>
          {t(title)}
      </div>
      <div className='no-access-message-container'>
          {t(message)}
      </div>
    </div>
  );
};

export default NoAccessPage;
